// Brand mark (DESIGN.md 9.2): a single geometric "A" chevron with a four-point
// forge spark, currentColor-driven. Decorative -> aria-hidden; the adjacent text
// label carries the accessible name.

interface Props {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 24, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={className}
      focusable="false"
    >
      {/* "A" chevron */}
      <path
        d="M16 4 L27 27 H21.5 L16 14.5 L10.5 27 H5 Z"
        fill="currentColor"
      />
      {/* four-point forge spark */}
      <path
        d="M16 16.5 L17.4 19.2 L20.1 20.6 L17.4 22 L16 24.7 L14.6 22 L11.9 20.6 L14.6 19.2 Z"
        fill="var(--surface)"
      />
    </svg>
  );
}
